import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import styles from './AdminLogin.module.css';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = login(credentials.username, credentials.password);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className={styles['admin-login-page']}>
      <div className={styles['login-container']}>
        <div className={styles['login-card']}>
          <div className={styles['login-header']}>
            <h1 className={styles['login-title']}>Queens Hotel Admin</h1>
            <p className={styles['login-subtitle']}>Please sign in to continue</p>
          </div>

          <form onSubmit={handleSubmit} className={styles['login-form']}>
            {error && (
              <div className={styles['error-message']}>
                {error}
              </div>
            )}

            <div className={styles['form-group']}>
              <label htmlFor="username" className={styles['form-label']}>
                Username
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={credentials.username}
                onChange={handleChange}
                className={styles['form-input']}
                required
                autoComplete="username"
              />
            </div>

            <div className={styles['form-group']}>
              <label htmlFor="password" className={styles['form-label']}>
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                className={styles['form-input']}
                required
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className={styles['login-button']}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className={styles['login-footer']}>
            <p className={styles['footer-text']}>
              For authorized personnel only
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;